import React, {useEffect, useRef, useState} from "react";
import {FaExclamationCircle} from "react-icons/fa";
import {VARIANT} from "../../../constants";
import Button from "../Button";

const OTPInput = ({handleSubmitOTP}) => {
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [error, setError] = useState("");
    const inputRefs = useRef([]);

    useEffect(() => {
        inputRefs.current[0].focus();
    }, []);

    const handleChange = (index, value) => {
        if (isNaN(value)) {
            setError("Invalid input. Please enter numbers only.");
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        setError("");

        if (value !== "" && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && index > 0 && otp[index] === "") {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleSubmit = () => {
        if (otp.some((digit) => digit === "")) {
            setError("Incomplete OTP. Please fill all fields.");
        } else {
            setError("");
            handleSubmitOTP && handleSubmitOTP(otp.join(""))
        }
    };

    return (
        <div className="w-full max-w-md">
            <div className="flex flex-row justify-center gap-2.5 mb-6">
                {otp.map((digit, index) => (
                    <input
                        key={index}
                        type="number"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        ref={(el) => (inputRefs.current[index] = el)}
                        className={`w-10 h-10 text-sm text-center border rounded-lg focus:outline-none focus:ring transition-all ${error ? "border-red-500" : "border-gray-300"}`}
                        aria-label={`OTP digit ${index + 1}`}
                    />
                ))}
            </div>
            {error && (
                <div className="flex items-center text-[#E4626F] mb-4">
                    <FaExclamationCircle className="mr-2"/>
                    <span>{error}</span>
                </div>
            )}
            <Button
                disabled={otp.some((digit) => digit === "")}
                variant={VARIANT.PRIMARY}
                className='w-full h-[44px] disabled:opacity-50'
                onClick={handleSubmit}
            >
                Xác nhận
            </Button>
        </div>
    );
};

export default OTPInput;
